import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const ChangeChecklistItem = graphql.persisted(
  "ChangeChecklistItem",
  graphql(`mutation ChangeChecklistItem($input: ChangeChecklistItemInput!) {
    changeChecklistItem(input: $input) {
      item { id state completedAt completedVia completedNote waivedReason keptAsItIs }
      errors
    }
  }`)
);

export { ChangeChecklistItem };
export function useChangeChecklistItem() {
  return useMutation(ChangeChecklistItem);
}
